import Vue from 'vue'
import Router from 'vue-router'
import {
  getCookie,
  setCookie
} from '../../utils/utils.js'
import {
  interOutnetConfig,
  getConfigurationInformation
} from "../../utils/appointment.url.js";
import store from './store.js'
// 预约须知
const appointmentNotice = () => import('./views/appointmentNotice/index.vue');
// 选择预约大厅
const chooseHall = () => import('./views/chooseHall/index.vue');
//选择预约单位
const chooseUnit = () => import('./views/chooseUnit/chooseUnit.vue');
//选择预约单位
const chooseType = () => import('./views/chooseType/chooseType.vue');
//预约时间
const reservation = () => import('./views/reservation/index.vue')
//填写基本信息
const basicInfo = () => import('./views/fillInBasicInfo/basicInfo.vue');
//完成预约
const orderComplete = () => import('./views/orderComplete/orderComplete.vue');
//查询预约信息
const reserveInfo = () => import('./views/reserveInfo/index.vue');
// 2.0新增页面
// 选择服务类型
const serviceType = () => import('./views/serviceType/index.vue');
const businessType = () => import('./views/businessType/index.vue');
const serviceHall = () => import('./views/serviceHall/index.vue');
const myAppointMent = () => import('./views/myAppointMent/index.vue');
const complete = () => import('./views/complete/index.vue');

// V2.1.0
// 入口页面
const index = () => import('./views/index/index.vue');
// 通用预约-选择大厅页面
const selectUnitCurrency = () => import('./views/selectUnitCurrency/index.vue');
const selectBusinessCurrency = () => import('./views/selectBusinessCurrency/index.vue');
// 禅道 8372 新增一个导航页跟一个错误页
const errorPage = () => import('./views/errorPage/error.vue');
const guidePage = () => import('./views/guidePage/guide.vue');

// 电话预约
const phoneAppointment = () => import('./views/phoneAppointment/index.vue');

//是否需要登录
Vue.use(Router)
const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/appointmentNotice',
      name: 'appointmentNotice',
      component: appointmentNotice,
      meta: {
        title: '预约须知', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/',
      redirect: '/index',
      meta: {
        // requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      },
    },
    {
      path: '/chooseHall',
      name: 'chooseHall',
      component: chooseHall,
      meta: {
        title: '选择预约大厅', // 页面标题
        // requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/chooseUnit',
      name: 'chooseUnit',
      component: chooseUnit,
      meta: {
        title: '选择预约单位', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/chooseType',
      name: 'chooseType',
      component: chooseType,
      meta: {
        title: '选择预约类型', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/reservation',
      name: 'reservation',
      component: reservation,
      meta: {
        title: '选择预约时间', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/basicInfo',
      name: 'basicInfo',
      component: basicInfo,
      meta: {
        title: '填写基本信息', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/orderComplete',
      name: 'orderComplete',
      component: orderComplete,
      meta: {
        title: '预约完成', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/reserveInfo',
      name: 'reserveInfo',
      component: reserveInfo,
      meta: {
        title: '查询预约信息', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/serviceType',
      name: 'serviceType',
      component: serviceType,
      meta: {
        title: '选择服务类型', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/businessType',
      name: 'businessType',
      component: businessType,
      meta: {
        title: '选择业务类型', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/serviceHall',
      name: 'serviceHall',
      component: serviceHall,
      meta: {
        title: '选择服务大厅', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/myAppointMent',
      name: 'myAppointMent',
      component: myAppointMent,
      meta: {
        title: '我的预约', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/complete',
      name: 'complete',
      component: complete,
      meta: {
        title: '预约成功', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/selectUnitCurrency',
      name: 'selectUnitCurrency',
      component: selectUnitCurrency,
      meta: {
        title: '选择服务大厅', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/selectBusinessCurrency',
      name: 'selectBusinessCurrency',
      component: selectBusinessCurrency,
      meta: {
        title: '选择业务', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '我要预约', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/error',
      name: 'error',
      component: errorPage,
      meta: {
        title: '错误页面', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/guide',
      name: 'guide',
      component: guidePage,
      meta: {
        title: '引导页', // 页面标题
        // requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/phoneAppointment',
      name: 'phoneAppointment',
      component: phoneAppointment,
      meta: {
        title: '人工预约'
      }
    }
  ]
})

/**
 * @param {string} url url参数
 * @param {string} param 要检测的参数
 * @param {RegExp} reg 要检测的参数的正则
 * @param {string=} routerAdd 路由地址，可选
 * @description 检查参数是否在路由前面
 * */
function checkQuery(url, param, reg, routerAdd) {
  let checkArr = url.split(param)
  let routerParam = /#\/[\w]{1,}/
  if (routerParam.test(checkArr[1]) || !routerParam.test(url)) {
    let query = reg.exec(url)[0]
    location.href = location.origin + location.pathname + '#' + routerAdd + query
  }
}
console.log('-----进入');

function getOutnetConfig() {
  return new Promise((resolve, reject) => {
    interOutnetConfig({
          key: "RESERVE_ISNEED_LOGIN"
        },
        "get"
      ).then(res => {
        console.log('-----进入接口');
        if (res.status == 200) {
          if (res.data.value == 1) {
            store.commit('loginState', true);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      })
      .catch(err => {
        console.log(err);
        reject(err);
      });
  })
}
// 路由拦截
router.beforeEach(async (to, from, next) => {
  checkQuery(location.href, '?access_token=', /\?access_token=[\w\-@]{1,}/, to.path);
  // 设置全局标题
  document.title = to.meta.title || '统一申办'
  const cookieToken = location.href.split('access_token=')[1];
  // console.log('cookieToken=',cookieToken);
  const cookie = getCookie('access-token')
  //console.log('cookie-----------')

  let savedConfig = JSON.parse(sessionStorage.getItem('appointmentConfig'));
  let reserveDescStatus = savedConfig && savedConfig.reserveDescStatus; // 预约须知是否开启（1：开启，其余关闭）
  // console.log('---1---reserveDescStatus', reserveDescStatus);
  // console.log('---2---before if savedConfig', savedConfig);
  if (!savedConfig) {
    // console.log('---3---before try savedConfig', savedConfig);
    try {
      let getConfigRes = await getConfigurationInformation({}, 'GET');
      if (getConfigRes.status == '200') {
        // console.log('---4---after get data', getConfigRes.data);
        sessionStorage.setItem('appointmentConfig', JSON.stringify(getConfigRes.data));
        reserveDescStatus = getConfigRes.data.reserveDescStatus;
      }
    } catch (err) {
      console.log(err);
    }
  }
  // console.log('---5---after get before if reserveDescStatus', reserveDescStatus);
  if (reserveDescStatus == 1) {
    let readNoticeStatus = sessionStorage.getItem('readNoticeStatus'); // 1为已阅读
    // console.log('---6---before if readNoticeStatus', readNoticeStatus);
    // console.log('---6.5---before if to.path', to.path);
    if (to.path === '/index' && !readNoticeStatus) {
      // console.log('---7---after if reserveDescStatus', reserveDescStatus);
      next({
        name: 'appointmentNotice',
        query: to.query
      });
    }
  }

  if (to.path === '/appointmentNotice' || to.path === '/index' || to.path === '/error' || to.path === '/guide') {
    // console.log('---8---after if to.path', to.path);
    next();
  } else {
    getOutnetConfig().then(res => {
      if (res) { // 判断该路由是否需要登录权限
        // console.log('---9---after if res', res);
        // console.log(cookie)
        if (cookie) { //
          next();
        } else {
          // console.log('au-------')
          if (cookieToken) {
            // console.log('au-------1')
            setCookie('access-token', cookieToken);
            let query = to.query
            delete query.access_token
            store.commit('loginState', true);
            next();
          } else {
            window.location.href = `${process.env.BASE_URL}entering.html?rURL=${encodeURIComponent(window.location.href)}`;
          }
        }
      } else {
        next();
      }
    })
  }
})

export default router